module.exports = __webpack_public_path__ + "img/guandai_xc3.34559cdd.jpg";